<template>
    <div id="index">
        <dv-full-screen-container class="bg">
            <dv-loading v-if="loading">Loading...</dv-loading>
            <div v-else class="host-body">
                <div class="d-flex jc-center">
                    <dv-decoration-10 style="width:33.3%;height:.0625rem;" />
                    <div class="d-flex jc-center">
                        <dv-decoration-8 :color="['#568aea', '#000000']" style="width:2.5rem;height:.625rem;" />
                        <div class="title">
                            <span class="title-text">百安消防数据可视化平台</span>
                            <dv-decoration-6
                                    class="title-bototm"
                                    :reverse="true"
                                    :color="['#50e3c2', '#67a1e5']"
                                    style="width:3.125rem;height:.1rem;"
                            />
                        </div>
                        <dv-decoration-8
                                :reverse="true"
                                :color="['#568aea', '#000000']"
                                style="width:2.5rem;height:.625rem;"
                        />
                    </div>
                    <dv-decoration-10 style="width:33.3%;height:.0625rem; transform: rotateY(180deg);" />
                </div>

                <!-- 第二行 -->
                <div class="d-flex jc-between px-2">
                    <div class="d-flex" style="width: 40%">
                        <div
                                class="react-right ml-4"
                                style="width: 6.25rem; text-align: left;background-color: #0f1325;"
                        >
                            <span class="react-before"></span>
                            <span class="text"></span>
                        </div>
                        <div class="react-right ml-3" style="background-color: #0f1325;">
<!--                            <span class="text colorBlue">数据分析2</span>-->
                        </div>
                    </div>
                    <div style="width: 40%" class="d-flex">
                        <div class="react-left mr-3" style="background-color: #0f1325;">
<!--                            <span class="text fw-b">vue-big-zhcf_screen</span>-->
                        </div>
                        <div
                                class="react-left mr-4"
                                style="width: 6.25rem; background-color: #0f1325; text-align: right;"
                        >
                            <span class="react-after"></span>
                            <span class="text">{{date}}</span>
                        </div>
                    </div>
                </div>
                <div class="body-box">
                    <!-- 第三行数据 -->
                    <div class="content-box3">
                        <div>
                            <div class="content-box3-1">
                                <div>
                                    <div class="left">
                                        <dv-border-box-12>
                                           <tree
                                                   :address-tree="addressTree"
                                                   @getParams="getParams"
                                           ></tree>
                                        </dv-border-box-12>
                                    </div>
                                </div>
                                <!-- 中间 -->
                                <div>

                                    <dv-border-box-12>
                                            <areaMap
                                                    v-if="reset"
                                                    :location="map1Data"
                                            ></areaMap>


                                    </dv-border-box-12>

                                </div>
                                <!-- 中间 -->
                            </div>
                            <div class="content-box3-2">
                                <dv-border-box-12>
                                    <detail
                                            :info="deviceInfo"
                                    ></detail>
                                </dv-border-box-12>
                                <dv-border-box-12>
                                    <line1
                                            :line1_data="line1Data"
                                    ></line1>
                                </dv-border-box-12>
                                <dv-border-box-12>
                                    <line2
                                            :line2_data="line2Data"
                                    ></line2>
                                </dv-border-box-12>
                            </div>
                        </div>

                        <div>
                            <div class="content-box3-3">
                                <dv-border-box-12>
                                    <list1
                                        :config="list_config"
                                    ></list1>
                                </dv-border-box-12>
                            </div>

                            <div class="content-box3-3">
                                <dv-border-box-12>
                                    <list2
                                        :config="list_config1"
                                    ></list2>
                                </dv-border-box-12>
                            </div>
                        </div>
                    </div>



                </div>
            </div>
        </dv-full-screen-container>
    </div>
</template>

<script>
  import areaMap from "../components/echart/map/areaMap";
  import tree from "../components/echart/tree";
  import axios from 'axios'
  import List1 from "./screen2/list1";
  import List2 from "./screen2/list2";
  import Detail from "./screen2/detail";
  import line1 from "./screen2/line1";
  import line2 from "./screen2/line2";
  export default {
    data() {
      return {
        loading: true,
        admin_id: '',
        chartData: [],
        list_config: [],
        list_config1: [],
        map1Data: [],
        date:'',//当前时间
        addressTree: [],
        device_imei: '',
        deviceInfo: {},
        reset: false,
        line1Data: [],
        line2Data: []
      };
    },
    components: {
      Detail,
      List2,
      List1,
      areaMap,
      tree,
      line1,
      line2
    },
    mounted() {
      this.fetchList()
      setInterval(this.getTime, 1000)
      let time = 1000 * 60 * 30 //每30分钟
      setInterval(this.fetchList, time) //一小时刷新一次
    },
    methods: {
      filterNode(value, data) {
        if (!value) return true;
        return data.label.indexOf(value) !== -1;
      },
      getParams(e){
        this.device_imei = e.device_imei
        if (this.device_imei && this.device_imei !== undefined){
          this.fetchList()
        }
      },
      cancelLoading() {
        setTimeout(() => {
          this.loading = false;
        }, 500);
      },
      fetchList(){
        this.admin_id = this.$route.query.admin_id
        console.log(this.admin_id)
        this.reset = false
        if (this.admin_id == '' || this.admin_id == undefined){
          this.loading = false;
          return
        }else{
          this.loading = true;
          axios.get('/api/Screen/getScreenAllChart2?admin_id='+this.admin_id+'&imei='+this.device_imei).then(res => {
            if (res.code == 0){
              return
            }
            this.chartData = res.data.data
            this.list_config = {
              header: ["采集时间", "日志内容"],
              data: this.chartData.log_list,
              rowNum: 10, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              align: ["center"],
              columnWidth: [150],
            }

            this.list_config1 = {
              header: ["操作时间", "大事件"],
              data: this.chartData.life_list,
              rowNum: 10, //表格行数
              headerHeight: 35,
              headerBGC: "#0f1325", //表头
              oddRowBGC: "#0f1325", //奇数行
              evenRowBGC: "#171c33", //偶数行
              align: ["center"],
              columnWidth: [120],

            }
            this.addressTree = this.chartData.addressTree
            this.deviceInfo = this.chartData.deviceInfo
            this.map1Data = this.chartData.mapData
            this.line2Data = this.chartData.line2
            this.line1Data = this.chartData.line1
            setTimeout(() => {
              this.loading = false;
              this.reset = true
            }, 500);
          })
        }

      },
      // 获取当前时间时分秒
      getTime () {
        var date=new Date();
        var year=date.getFullYear(); //获取当前年份
        var mon=date.getMonth()+1; //获取当前月份
        var da=date.getDate(); //获取当前日
        var day=date.getDay(); //获取当前星期几
        var h=date.getHours(); //获取小时
        var m=date.getMinutes(); //获取分钟
        var s=date.getSeconds(); //获取秒
        // 当分秒不足10时，前面加0
        let mm
        if (m < 10){
          mm = "0" + m;
        }else {
          mm = m;
        }
        let ss
        if (s < 10){
          ss = "0" + s;
        }else {
          ss = s;
        }
        let week
        if (day === 1){
          week = "一";
        }
        else if (day === 2){
          week = "二";
        }
        else if (day === 3){
          week = "三";
        }
        else if (day === 4){
          week = "四";
        }
        else if (day === 5){
          week = "五";
        }
        else if (day === 6){
          week = "六";
        }
        else if (day === 0){
          week = "日";
        }
        this.date = year + '年' + mon + '月' + da + '日 '
          + h + ':' + mm + ':' + ss + ' 星期' + week
      },
    }
  };
</script>

<style lang="scss">
    @import "../assets/scss/index.scss";
    .left{
        height: 6rem;
    }
    .btn{
        background-color: #5cd9e8;
        width: 100px;
    }
</style>
